import { render, staticRenderFns } from "./ListNavigations.vue?vue&type=template&id=4a8639b8&scoped=true&"
import script from "./ListNavigations.vue?vue&type=script&lang=js&"
export * from "./ListNavigations.vue?vue&type=script&lang=js&"
import style0 from "./ListNavigations.vue?vue&type=style&index=0&id=4a8639b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8639b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a8639b8')) {
      api.createRecord('4a8639b8', component.options)
    } else {
      api.reload('4a8639b8', component.options)
    }
    module.hot.accept("./ListNavigations.vue?vue&type=template&id=4a8639b8&scoped=true&", function () {
      api.rerender('4a8639b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/SiteBuilder/components/ListNavigations.vue"
export default component.exports